import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { X_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const XIcon = (props: IconGlyphProps) => <Icon {...props} glyph={X_GLYPH} />;
